<app-navbar></app-navbar>
<!-- <app-home></app-home> -->


<div class="app-container">
    <div class="content-wrap">
        <router-outlet />
    </div>
    <app-footer></app-footer>
</div>